import { SkeletonRow, TableSkeletonContainer } from './styles';

const TableSkeleton = ({ rows = 8 }) => {
  return (
    <TableSkeletonContainer>
      {/* <TableHeader />  */}
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index} />
      ))}
    </TableSkeletonContainer>
  );
};

export default TableSkeleton;